export default {
  company: {},
  loadingCompany: false,
  loadingCompanyFailed: false,
  loadingCompanySucceeded: false,
  loadingCompanyErrors: null,

  updatingCompany: false,
  updatingCompanyFailed: false,
  updatingCompanySucceeded: false,
  updatingCompanyErrors: null,

  companies: [],
  loadingCompanies: false,
  loadingCompaniesFailed: false,
  loadingCompaniesSucceeded: false,
  loadingCompaniesErrors: null,

  timezones: [],
  loadingTimezones: false,
  loadingTimezonesFailed: false,
  loadingTimezonesSucceeded: false,
  loadingTimezonesErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/company/state.js